var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',[_c('v-col',[_c('v-text-field',{attrs:{"placeholder":"Search","background-color":"fossil","append-icon":"mdi-magnify","hide-details":"","color":"black","solo":"","dense":""},on:{"input":_vm.onInput},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }